module.exports = __webpack_public_path__ + "img/undraw_coffee_break_j3of.9ced9d77.svg";